import { useMutation, useQueryClient } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'
import { useUser } from '../user/useUser'
import { TEAM_QUERY_KEY, useTeam } from './useTeam'
import { TEAMS_QUERY_KEY } from './useTeams'

export function useUpdateTeamName(teamID: string) {
  const queryClient = useQueryClient()
  const { data: user } = useUser()
  const { data: team } = useTeam(teamID)

  return useMutation({
    mutationFn: async (newName: string) => {
      if (!user) throw new Error('User not found')
      if (!team) throw new Error('Team not found')
      if (team.leaderID !== user.id) throw new Error('Only team leaders can update the team name')

      await dataSource.updateTeamName(team.id, newName)
      return team
    },
    onSuccess: (team) => {
      queryClient.invalidateQueries({ queryKey: TEAM_QUERY_KEY(team.id) })
      queryClient.invalidateQueries({ queryKey: TEAMS_QUERY_KEY(team.challengeID) })
      queryClient.invalidateQueries({ queryKey: ['leaderboard'] })
    },
  })
}
